import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { ApsOptionMenu, ApsGalleryInputButton, ApsModalBody, ApsModalHeader, ApsCameraInputButton } from 'UserExperience/portal-vnext';

const AddFileModal = ({ visible, onFileSelect, onCancel }) => {

  const { t } = useTranslation();
  const modalTitle = t('documentPages.addPage.title');
  const galleryInputButtonLabel = t('documentPages.addPage.choosePhotoButton');
  const cameraInputButtonLabel = t('documentPages.addPage.takePicButton');

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      closable={false}
      footer = {null}
      centered={true}
      wrapClassName="modal-size-is-small"
      bodyStyle={{padding:0, fontSize: 16}}
      width={280}
      destroyOnClose={true}
    >
      {/* existing portal css needs some wrapper element so modal font, etc., will be applied */}
      <emulate-ng-include>
        <ApsModalHeader
          titleText={modalTitle}
          titleAlign="center"
          titleSize="small"
          onClick={onCancel}
          closeButton={true}
          closeButtonSize="small"
        />
        <ApsModalBody>
          <ApsOptionMenu menuAlign="center">
            <li>
              <ApsGalleryInputButton
                buttonLabel={galleryInputButtonLabel}
                onSelect={onFileSelect}
                accept="image/*"
              />
            </li>
            <li>
              <ApsCameraInputButton
                buttonLabel={cameraInputButtonLabel}
                onSelect={onFileSelect}
                accept="image/*"
              />
            </li>
          </ApsOptionMenu>
        </ApsModalBody>
      </emulate-ng-include>
    </Modal>
  );
};

export default AddFileModal;